module.exports = __webpack_public_path__ + "static/media/s_icon_03.c2e408db.png";